import * as bootstrap from 'bootstrap'

// JS
import './mapbox.js';
import './video.js';
import './nav.js';
import './swiper.js'
import './observer.js';
import './loadmore.js';

// CSS
import '../scss/main.scss';

// Activation des tooltips
const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
const tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
    return new bootstrap.Tooltip(tooltipTriggerEl)
})

const app = {

    init: function(){
        app.removeRgpdConsent();
        // app.loading();
        // app.test();
    },

    removeRgpdConsent: function(){
        const consentFrame = document.querySelector('.cky-revisit-bottom-left');
        if(!consentFrame) return;
        consentFrame.style.display = 'none';
    },

/*     loading: function() {
        if (document.querySelector('.header video')) {
            const video = document.querySelector('.header video');
            video.onloadeddata = function() {
                const loader = document.querySelector('.loader');
                loader.classList.add('loader-hidden');

                loader.addEventListener('transitionned', () => {
                    loader.remove();
                })
            }
        }
    }, */
};

document.addEventListener('DOMContentLoaded', app.init);